import { Steps } from "antd";
import TimeAgo from "react-timeago";
import dayjs from "dayjs";

import polishStrings from "react-timeago/lib/language-strings/pl";
import buildFormatter from "react-timeago/lib/formatters/buildFormatter";

const formatter = buildFormatter(polishStrings);
const calculateDuration = (duration) => {
  if (!duration) return "";

  if (duration > 86_400) {
    const round_duration_in_days = Math.ceil(duration / 86_400);
    return `${round_duration_in_days} dni`;
  }

  if (duration < 86_400 && duration >= 3_600) {
    //doba
    const round_duration_in_hours = Math.ceil(duration / 3_600);
    return `${round_duration_in_hours}h`;
  }

  if (duration < 3_600 && duration >= 60) {
    //godzina
    const round_duration_in_minutes = Math.ceil(duration / 60);
    return `${round_duration_in_minutes}min`;
  }

  if (duration < 60) {
    const round_duration_in_seconds = Math.ceil(duration);
    return `${round_duration_in_seconds}s`;
  }
};
const getCurrentStep = ({ status, service_date }) => {
  switch (status) {
    case "cancelled":
    case "completed":
      return 3;
    case "in_progress":
      return 2;
    case "new":
      return service_date ? 1 : 0;
    default:
      return 0;
  }
};

const Statuses = ({ data }) => {
  const current_step = getCurrentStep({
    status: data?.status,
    service_date: data?.service_date,
  });
  return (
    <Steps
      className="issue-steps"
      style={{ margin: "20px auto", maxWidth: 1000 }}
      current={current_step}
      items={[
        {
          title: "Nowe",
          className: "status_new",
          description: data?.created_at
            ? dayjs(data.created_at).format("DD-MM-YYYY HH:mm")
            : "-",
        },
        {
          title: "Umówione",
          className: "status_service",
          description: data?.service_date ? (
            <>
              {`${dayjs(data.service_date).format(
                "DD-MM-YYYY HH:mm"
              )} - ${dayjs(data.service_date_delayed).format("HH:mm")}`}
              <br />
              <strong>
                <TimeAgo date={data.service_date} formatter={formatter} />
              </strong>
            </>
          ) : (
            "-"
          ),
        },
        {
          title: "W trakcie",
          className: "status_in_progress",
          description: data?.started_at
            ? dayjs(data.started_at).format("DD-MM-YYYY HH:mm")
            : "-",
        },
        data?.status === "cancelled"
          ? {
              title: "Anulowane",
              className: "status_cancelled",
              description: data?.cancelled_at
                ? dayjs(data.cancelled_at).format("DD-MM-YYYY HH:mm")
                : "-",
            }
          : {
              title: "Zakończone",
              className: "status_completed",
              description:
                data?.status === "completed" && data?.completed_at ? (
                  <>
                    {dayjs(data.completed_at).format("DD-MM-YYYY HH:mm")} <br />
                    <strong>({calculateDuration(data.duration)})</strong>
                  </>
                ) : (
                  "-"
                ),
            },
      ]}
    />
  );
};

export default Statuses;
